import { makeGetApiRequest } from '@common/index'
import createDataContext from './createDataContext'
import axios from 'axios'

interface StateType {
    miscModal: { visibility: boolean, coords: { x: number, y: number }, children },
    workshopList: { id: string, entityName: string, entityDisplayName: string, nonSortingEntities: any[], defaultReceiveLocation: any }[],
    workshop: { id: string, entityName: string, entityDisplayName: string, nonSortingEntities: any[] },
    mainHeaderLoading: boolean,
    inventoryReplenishmentData: any,
    purchaseRequestData: any,
    catalogueProducts: any
}

interface ActionType {
    payload: any,
    type: string
}

const initialState: StateType = {
    miscModal: { visibility: false, coords: { x: -1, y: -1 }, children: null },
    workshopList: [],
    workshop: { id: '', entityName: '', entityDisplayName: '', nonSortingEntities: [] },
    mainHeaderLoading: false,
    inventoryReplenishmentData: {},
    purchaseRequestData: {},
    catalogueProducts: {}
}

const reducer = (state, action: ActionType) => {

    switch(action.type)
    {
        case 'setMiscModal': return { ...state, miscModal: action.payload }

        case 'setWorkshop': return { ...state, workshop: action.payload }

        case 'setWorkshopList': return { ...state, workshopList: action.payload }

        case 'setMainHeaderLoading': return { ...state, mainHeaderLoading: action.payload }

        case 'getInventoryReplenishmentData': return { ...state, inventoryReplenishmentData: action.payload }

        case 'getPurchaseRequestData': return { ...state, purchaseRequestData: action.payload }

        case 'getAllProducts': return { ...state, catalogueProducts: action.payload }

        case 'logout': return initialState

        default: return state
    }

}

const closePurchaseRequest = dispatch => {

    return async (variables, closePurchaseRequest, callback?: (data?) => void, err_callback?: (message) => void) => {
        
        try
        {

            const response = await closePurchaseRequest({ variables })

            !!callback ? callback?.(response.data?.closePurchaseRequest) : null

        } catch(e)
        {
            console.log('CLOSE PURCHASE REQUEST ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const downloadExcel = dispatch => {

    return async (url: string, callback?: (data) => void, err_callback?: (message) => void) => {

        try
        {

            const response = await makeGetApiRequest(url, {}, 'Keycloak-Authorization', 'Bearer', 'spares');

            const URL = response?.request?.responseURL;
            const a = document.createElement("a")
            a.href = URL
            a.click();

            !!callback ? callback?.(url) : null

        } catch(e)
        {
            console.log('DOWNLOAD EXCEL ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }
    
}

const getAllProductsInventoryDetails = dispatch => {

    return async (variables, getAllProductsInventoryDetails, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {

            const response = await getAllProductsInventoryDetails({ variables })

            !!callback ? callback?.(response.data?.getInventoryByProducts) : null

        } catch(e)
        {
            console.log('GET ALL PRODUCTS INVENTORY DETAILS ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const addVendorToPurchaseRequestParts = dispatch => {

    return async (variables, addVendorToPurchaseRequestParts, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {
            
            const response = await addVendorToPurchaseRequestParts({ variables })

            !!callback ? callback?.(response.data?.addInventoryRequestItemToVendorMutation) : null

        } catch(e)
        {
            console.log('ADD VENDOR TO PURCHASE REQUEST PARTS ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const replacePurchaseRequestItem = dispatch => {

    return async (variables, replacePurchaseRequestItem, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {
            const response = await replacePurchaseRequestItem({ variables })

            !!callback ? callback?.(response.data?.replacePurchaseRequestItem) : null

        } catch(e)
        {
            console.log('REPLACE PURCHASE REQUEST ITEM', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const getAllCategories = dispatch => {

    return async (variables, getAllCategories, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {

            const response = await getAllCategories({ variables })

            !!callback ? callback?.(response.data?.getAllCategories) : null

        } catch(e)
        {
            console.log('GET ALL CATEGORIES ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const getAllBrands = dispatch => {

    return async (variables, getAllBrands, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {

            const response = await getAllBrands({ variables })

            !!callback ? callback?.(response.data?.getAllBrands) : null

        } catch(e)
        {
            console.log('GET ALL BRANDS ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const getAllProducts = dispatch => {

    return async (variables, getAllProducts, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {

            const response = await getAllProducts({ variables })

            dispatch({ type: 'getAllProducts', payload: response.data?.getAllProducts })

            !!callback ? callback?.(response.data?.getAllProducts) : null

        } catch(e)
        {
            console.log('GET ALL PRODUCTS ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const getAllVendors = dispatch => {

    return async (variables, getAllVendors, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {

            const response = await getAllVendors({ variables })

            !!callback ? callback?.(response.data?.getAllVendors) : null

        } catch(e)
        {
            console.log(e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const getPurchaseRequestData = dispatch => {

    return async (variables, getRequest, callback?: (data?) => void, err_callback?: (message) => void) => {
        
        try
        {

            const response = await getRequest({ variables })

            dispatch({ type: 'getPurchaseRequestData', payload: response.data?.getRequest })

            !!callback ? callback?.(response.data?.getRequest) : null

        } catch(e)
        {
            console.log('GET PURCHASE REQUEST DATA ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const getInventoryReplenishmentData = dispatch => {

    return async (variables, getInventoryReplenishmentData, callback?: (data) => void, err_callback?: (message) => void) => {

        try
        {

            const response = await getInventoryReplenishmentData({ variables })

            dispatch({ type: 'getInventoryReplenishmentData', payload: response.data?.getAllRequests })

            !!callback ? callback?.(response.data?.getAllRequests) : null

        } catch(e)
        {
            console.log('GET INVENTORY REPLENISHMENT DATA', e?.message)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const setMainHeaderLoading = dispatch => {

    return (mainHeaderLoading: boolean, callback?) => {

        dispatch({ type: 'setMainHeaderLoading', payload: mainHeaderLoading })

        callback?.()

    }

}

const setWorkshopList = dispatch => {

    return async (getEntities, callback?, err_callback?: (message) => void) => {

        try
        {

            const response = await getEntities()

            console.log('RESPONSE', response.data)

            dispatch({ type: 'setWorkshopList', payload: response.data?.getEntities?.filter?.(val => (val?.nonSortingEntities?.length > 0))?.map(val => ({ id: val?.id, entityName: val?.entityName, entityDisplayName: val?.entityDisplayName, nonSortingEntities: val?.nonSortingEntities, defaultReceiveLocation: val?.defaultReceiveLocation })) })

            !!callback ? callback?.(response.data?.getEntities?.filter?.(val => (val?.nonSortingEntities?.length > 0))?.map(val => ({ id: val?.id, entityName: val?.entityName, entityDisplayName: val?.entityDisplayName, nonSortingEntities: val?.nonSortingEntities, defaultReceiveLocation: val?.defaultReceiveLocation }))) : null

        } catch(e)
        {
            console.log(e)
            err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const setWorkshop = dispatch => {

    return (workshopData, callback) => {

        console.log('WORK SHOP DATA', workshopData, workshopData?.defaultReceiveLocation)
        localStorage.setItem('default_entity_id', workshopData?.id)
        localStorage.setItem('default_receive_location_id', workshopData?.defaultReceiveLocation?.id)

        dispatch({ type: 'setWorkshop', payload: workshopData })

        callback && callback()
    }

}

const setMiscModal = dispatch => {

    return (visibility, coords, children) => {
        dispatch({ type: 'setMiscModal', payload: { visibility, coords, children } })
    }
}

const logout = dispatch => {

    return () => {
        dispatch({ type: 'logout', payload: {} })
    }

}

export interface InventoryReplenishmentInterface {
    state: StateType,
    setMiscModal: (visibility: boolean, coords: { x: number, y: number }, children) => void,
    setWorkshop: (workshopData, callback: () => void) => void,
    setWorkshopList: (getEntities, callback?, err_callback?: (message) => void) => Promise<void>,
    setMainHeaderLoading: (mainHeaderLoading: boolean, callback?) => void,
    getInventoryReplenishmentData: (variables, getInventoryReplenishmentData, callback?: (data) => void, err_callback?: (message) => void) => Promise<void>,
    getPurchaseRequestData: (variables, getRequest, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    getAllVendors: (variables, getAllVendors, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    getAllProducts: (variables, getAllProducts, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    getAllBrands: (variables, getAllBrands, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    getAllCategories: (variables, getAllCategories, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    replacePurchaseRequestItem: (variables, replacePurchaseRequestItem, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    addVendorToPurchaseRequestParts: (variables, addVendorToPurchaseRequestParts, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    getAllProductsInventoryDetails: (variables, getAllProductsInventoryDetails, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    downloadExcel: (url: string, callback?: (data) => void, err_callback?: (message) => void) => Promise<void>,
    closePurchaseRequest: (variables, closePurchaseRequest, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    logout: () => void
}

export const { Context: InventoryReplenishmentContext, Provider: InventoryReplenishmentProvider } = createDataContext(reducer,
    { setMiscModal, setWorkshop, setWorkshopList, setMainHeaderLoading, getInventoryReplenishmentData, getPurchaseRequestData, getAllVendors, getAllProducts, getAllBrands, getAllCategories, replacePurchaseRequestItem, addVendorToPurchaseRequestParts, getAllProductsInventoryDetails, downloadExcel, closePurchaseRequest, logout },
    initialState)
